export default function(x) {
    if (isNaN(x)) 
        return x
    
    if (x < 9999) {
        let i = 100,
            res = (parseInt(x * i)) / i

        while (!parseFloat(res) && i < 10000000) {
            i *= 10
            res = (parseInt(x * i)) / i
        }

        return res
    }
    if (x < 1000000) {
        return (x / 1000).toFixed(2) + 'K'
    }
    if (x < 10000000) {
        return (x / 1000000).toFixed(2) + 'M'
    }
    if (x < 1000000000000) {
        return (x / 1000000000).toFixed(2) + 'B'
    }
    if (x < 1000000000000000) {
        return (x / 1000000000000).toFixed(2) + 'T'
    }

    return '1T+'
}